export default "__VITE_ASSET__BEJWunfG__"